export default __webpack_public_path__ + "static/media/user.75b038d8.svg";